import { getClassNameFromSectionModelUtil } from 'models/utils/get-class-name-from-section'
import { loadLegacyReduxAction } from 'modules/redux/actions/legacy/load'
import getDomainMapKeyFromPathReduxUtil from 'modules/redux/utils/get-domain-map-key-from-path'
import getDomainPathFromSectionReduxUtil from 'modules/redux/utils/get-domain-path-from-section'
import isTemporaryIdReduxUtil from 'modules/redux/utils/is-temporary-id'
import getEndpointFromDomainMapValueReduxUtil from 'modules/redux/utils/legacy/get-endpoint-from-domain-map-value'
import getDomainMapValueFromPathRouteUtil from 'modules/routes/utils/get-domain-map-value-from-path'
import { logUtil } from 'packages/src'

/**
 * Loads a `Instance` of the given section.
 * @param  {Object} props
 * @param  {Object} props.route
 * @param  {Object} props.match
 * @param  {Object} props.[options={}]
 *         {Object} props.[options.params]
 *         {Object} props.[options.location]
 *         {Object} props.[options.ctx]
 * @returns {Function}
 */
export default function loadInstanceSectionAction ({
  route,
  match,
  options = {},
  ctx
}) {
  return dispatch => {
    const {
      section,
      path
    } = route
    const domainPath = getDomainPathFromSectionReduxUtil(section)
    const domainMapKey = getDomainMapKeyFromPathReduxUtil(domainPath)
    const domainMapValue = match.params[domainMapKey] || getDomainMapValueFromPathRouteUtil(path)

    const logPrefix = `domainMapValue=${domainMapValue} for domainPath=${domainPath} hasCtx=${!!ctx}`
    logUtil('loadInstanceSectionAction').debug(`${logPrefix}`)
    if (!domainMapValue) {
      logUtil('loadInstanceSectionAction').warn(`${logPrefix} [noop] no domainMapValue`)
      return
    }

    // e.g. /articles/-1
    if (
      isTemporaryIdReduxUtil(domainMapValue)
    ) {
      logUtil('loadInstanceSectionAction').warn(`${logPrefix} [noop] invalid `)
      ctx && (ctx.status = 404)
      return
    }

    const className = getClassNameFromSectionModelUtil(section)
    const endpoint = getEndpointFromDomainMapValueReduxUtil(
      className,
      domainMapValue
    )

    let remoteUrl
    if (route.isApp) {
      remoteUrl = TRAINING_API_ENDPOINT
    } else {
      remoteUrl = API_ENDPOINT
    }

    return dispatch(
      loadLegacyReduxAction({
        endpoint,
        path: domainPath,
        className,
        domainMapValue,
        options,
        remoteUrl
      })
    )
  }
}
